import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { COOKIE_NAME, COUNTRY_ENDPOINT, CountryFetchResponse } from './cookie.consent.config';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';

@Injectable()
export class CookieConsentService {
  private readonly isGdpr: Subject<boolean> = new Subject<boolean>();
  private userCountry = '';
  private readonly cookieConsent: string;
  private readonly countryFromUrl;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly cookieService: CookieService,
    @Inject('baseUrl') private readonly baseUrl: string,
    @Inject('isProd') private readonly isProd: boolean = true,
    private readonly router: Router,
    @Inject(PLATFORM_ID) private readonly platformId: string,
  ) {
    if (!this.baseUrl) {
      throw new Error('No base Url for cookie consent');
    }
    this.cookieConsent = this.cookieService.get(COOKIE_NAME);

    if (isPlatformBrowser(this.platformId)) {
      const countryFromUrl = new URLSearchParams(window.location.search).get('country');
      if (countryFromUrl && !this.isProd) {
        this.countryFromUrl = countryFromUrl;
      }
      this.fetchState().subscribe();
    }
  }

  private fetchState(): Observable<any> {
    let queryParams;
    if (this.countryFromUrl) {
      queryParams = { countryFromUrl: this.countryFromUrl };
    }
    return this.httpClient.get<CountryFetchResponse>(this.baseUrl + COUNTRY_ENDPOINT, { params: queryParams }).pipe(
      tap((resp: CountryFetchResponse) => {
        this.userCountry = resp.country;
        this.isGdpr.next(resp.isGDPR);
      }),
    );
  }

  get isEu(): Observable<boolean> {
    return this.isGdpr;
  }

  get cookieConsentRequired(): Observable<boolean> {
    return this.isEu.pipe(
      map((isEu: boolean) => {
        if (isEu) {
          return !!(!this.cookieConsent || this.cookieConsent === 'false');
        }
          return !!(this.cookieConsent && this.cookieConsent === 'false');
      }),
    );
  }

  get country(): string {
    return this.userCountry;
  }
}
